// extracted by mini-css-extract-plugin
export default {"forgotPasswordPage":"forgot-password-page_forgotPasswordPage__fUvY3","forgotPasswordForm":"forgot-password-page_forgotPasswordForm__Ae+xG"};